import styled, { IThemeColors } from '../../lib/styled_components';

const $ColorText = styled('span')<IThemeColors>`
  color: ${(p) => p.theme.colors[p.color]};
`;

export default $ColorText;
